import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import messageSlice from "./messageSlice";
import { toast } from "react-toastify";
import baseApi from "../Http/baseApi";
import { Link,useNavigate, Navigate } from "react-router-dom";

const getStoredAuth = () => {
  try {
    const stored = localStorage.getItem("userData");
    if (!stored) return null;

    const user = JSON.parse(stored);
    if (user?.user) {
      return { isLoggedIn: true, user: user.user, panel: user.panel };
    }

    localStorage.removeItem("userData");
    return null;
  } catch {
    localStorage.removeItem("userData");
    return null;
  }
};

const storedAuth = getStoredAuth();

// export const getLoggedInUserAsync = createAsyncThunk(
//     'auth/getLoggedInUserAsync',
//     async ()=>{
//          let userData = localStorage.getItem("userData");

//         return userData;

//     }
// );

export const postLoginAsync = createAsyncThunk(
  "auth/postLoginAsync",
  async (data) => {
    const { payload } = data;

    try {
      const response = await baseApi.post("auth/signin", payload );
      // if(response.status===200){
      //   toast.success("Success"); 
      // } 
      return response.data;
    } 
     catch(err){
       console.log("error",err.response)
       if(err.response.status === 404){ 
        // toast.error(err.response.data.message); 
        toast.error("Invalid Credentials!");
       }
     }
     
  }
);
export const logout = createAsyncThunk("auth/logout", async () => {
   localStorage.removeItem("userData");
 
  
});

export const changePasswordAsync = createAsyncThunk(
  "auth/changePasswordAsync",
  async (payload, { getState, rejectWithValue }) => {
    const { user, panel } = getState().auth;

    try {
      const response = await baseApi.post("auth/change-password", {
        id: user.id,
        panel,
        new_password: payload.newPassword,
      });
      return response.data;
    } catch (err) {
      const message =
        err.response?.data?.message || "Unable to update password.";
      return rejectWithValue(message);
    }
  }
);

const initialState = storedAuth ?? {
  isLoggedIn: false,
  user: null,
  panel: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: {
    // [getLoggedInUserAsync.fulfilled]: (state, action)=>{
    //     console.log('local data found');
    //     return {...state, user: action.payload, isLoggedIn: true, errorMessage:''} ;
    // },

    [postLoginAsync.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.panel = action.payload.panel;
      localStorage.setItem("userData", JSON.stringify(action.payload));

      // return {...state, user: action.payload, isLoggedIn: true, errorMessage:''} ;
      // return {...state, companies: action.payload} ;
    },

    [postLoginAsync.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.panel = null;

      // return {...state, user: {}, isLoggedIn: false, errorMessage:'Invalid Credentials!'} ;
    },
    [logout.fulfilled]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.panel = null;
    },
  },
});

export default authSlice;
